import { useMatches } from '@remix-run/react'

export default function useMatchesChildRoute<TChildRouteData>(
	route: string,
): [true, TChildRouteData] | [false, null] {
	const matches = useMatches()
	for (const match of matches) {
		if (match.id == `routes${route}`) {
			return [true, match.data as TChildRouteData]
		}
	}
	return [false, null]
}
